// AIDEV-NOTE: side-effect import: captures+strips chunk_reload before ./router (index.tsx keeps it
// above); exports nothing so it isn't reordered among its siblings.
import { captureChunkReloadParam } from './chunkLoadErrorHandler';

captureChunkReloadParam();
